import { VetClientModel, VetTaskClientModel } from "../../../../../../../../models/vetting/vetting.models";

export abstract class BaseRedMarblePlugin {
    
    data: any;
    rsData: any;
    vet: VetClientModel;
    vetTask: VetTaskClientModel;
    async activate(model: { vet: VetClientModel, vetTask: VetTaskClientModel }) {
        this.vet = model.vet;
        this.vetTask = model.vetTask;
        this.loadData();
    }

    loadData() {
        if (this.vetTask.thirdPartyPayload) {
            this.data = JSON.parse(this.vetTask.thirdPartyPayload);
        }
        if (this.vetTask.rightshipPayload) {
            this.rsData = JSON.parse(this.vetTask.rightshipPayload);
        }
    }
} 